/* Página NEMA 3R: plano por gabinete, vista por vista en celular, y comparador contra otro grado NEMA. */
(function () {
  var q = function (s) { return document.querySelector(s); };
  var svg = q('#n3-svg');
  if (!svg) return;
  var tabs = document.querySelectorAll('.n3-tabs button');
  var vb = document.querySelectorAll('.n3-vistas button');
  var cel = window.matchMedia('(max-width:720px)');
  var V = {
    1: ['20 20 300 445', '325 20 300 445'],
    2: ['30 20 300 445', '325 20 300 445'],
    3: ['30 28 345 435', '392 28 245 435'],
    4: ['20 6 350 462', '325 6 350 462']
  };
  var act = 2, vis = 0;
  function vista(i) {
    vis = i;
    var t = q('.n3-tabs button[data-t="' + act + '"]');
    vb[0].textContent = t.dataset.v1;
    vb[1].textContent = t.dataset.v2;
    vb.forEach(function (b, n) { b.setAttribute('aria-pressed', n === i); });
    svg.setAttribute('viewBox', cel.matches ? V[act][i] : '0 0 680 500');
    svg.dataset.v = i;
  }
  function ver(t) {
    act = t;
    tabs.forEach(function (b) { b.setAttribute('aria-selected', +b.dataset.t === t); });
    document.querySelectorAll('.n3-dib [data-d]').forEach(function (g) { g.classList.toggle('on', +g.dataset.d === t); });
    document.querySelectorAll('.n3-det-i').forEach(function (d) { d.hidden = +d.dataset.c !== t; });
    vista(0);
  }
  tabs.forEach(function (b) { b.addEventListener('click', function () { ver(+b.dataset.t); }); });
  vb.forEach(function (b) { b.addEventListener('click', function () { vista(+b.dataset.v); }); });
  if (cel.addEventListener) cel.addEventListener('change', function () { vista(vis); });
  vista(0);

  var cb = document.querySelectorAll('.n3-cmp button'), tb = q('#n3-tabla');
  function comp(n) {
    cb.forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.c === String(n)); });
    tb.querySelectorAll('tr').forEach(function (tr) {
      Array.prototype.forEach.call(tr.children, function (c, i) { c.classList.toggle('v', i + 1 === +n); });
    });
  }
  cb.forEach(function (b) { b.addEventListener('click', function () { comp(b.dataset.c); }); });
})();
